import React from "react";
import { Badge } from "reactstrap";

const Example = () => {
    return (
        <div className="reactstrap-badge-block">
            <Badge className="c-primary">Primary</Badge>

            <Badge className="c-secondary">Secondary</Badge>

            <Badge className="c-success">Success</Badge>

            <Badge className="c-danger">Danger</Badge>

            <Badge className="c-warning">Warning</Badge>

            <Badge className="c-info">Info</Badge>

            <Badge className="c-light">Light</Badge>

            <Badge className="c-dark">Dark</Badge>
        </div>
    );
};
export default Example;
